import { render, staticRenderFns } from "./details.vue?vue&type=template&id=1071ffa5&scoped=true"
import script from "./details.vue?vue&type=script&lang=js"
export * from "./details.vue?vue&type=script&lang=js"
import style0 from "./details.vue?vue&type=style&index=0&id=1071ffa5&prod&scoped=true&lang=css"
import style1 from "./details.vue?vue&type=style&index=1&id=1071ffa5&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/ad/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1071ffa5",
  null
  
)

export default component.exports